import {
  EDIT_SOFTSKILL_ABILITY,
  EDIT_SOFTSKILL_ABILITY_SUCCESS,
  EDIT_SOFTSKILL_ABILITY_CLEAN,
  EDIT_SOFTSKILL_ABILITY_ERROR,
} from "./actionTypes"

export const editSoftskillAbility = form => ({
  type: EDIT_SOFTSKILL_ABILITY,
  payload: { form },
})

export const editSoftskillAbilitySuccess = ability => {
  return {
    type: EDIT_SOFTSKILL_ABILITY_SUCCESS,
    payload: { ability },
  }
}

export const editSoftskillAbilityClean = () => {
  return {
    type: EDIT_SOFTSKILL_ABILITY_CLEAN,
    payload: {},
  }
}

export const editSoftskillAbilityError = error => {
  return {
    type: EDIT_SOFTSKILL_ABILITY_ERROR,
    payload: error,
  }
}
